export const GENERATE_P12_ROUTE = '/generate-p12';
export const RECOVER_PASSWORD_ROUTE = '/recover-password';
export const CHANGE_PASSWORD_ROUTE = '/change-password';
export const MAIN_ROUTE = '/main';
export const CERTIFICATE_REQUEST_ROUTE = '/certreq';
export const CERTIFICATE_REQUEST_PKCS10_ROUTE = '/certreqpkcs10';
export const ADMIN_ROUTE = '/admin';
export const REPORTS_ROUTE = '/reports';
